import {
  Badge,
  Button,
  Stack,
  styled,
  SxProps,
  Tab,
  Tabs,
} from '@mui/material';

import devices from '../../../../../styles/devices';

export const SelectedCount = styled('p')`
  color: var(--color-text-light);
  font-size: var(--font-sm);
  font-weight: var(--font-medium);
`;

export const SearchHeader = styled('header')`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  padding-block: var(--spacing-small);
  padding-inline: 0;

  @media ${devices.tabletS} {
    padding-inline: var(--spacing-big);
  }
`;

export const SelectionWrapper = styled(Stack)`
  align-items: center;
  flex-direction: row;
  gap: var(--spacing-small);
  justify-content: space-between;
`;

export const StyledBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    backgroundColor: 'var(--color-red-600)',
    right: 'calc(-1 * var(--spacing-small))',
    top: 'calc(-1 * var(--spacing-tiny))',
  },
}));

export const StyledButton = styled(Button)(() => ({
  '&.MuiButton-outlined:hover': {
    backgroundColor: 'transparent',
  },
}));

export const StyledTab = styled(Tab)(() => ({
  minWidth: 'auto',
  overflow: 'visible',
  paddingInline: 0,
}));

export const StyledTabs = styled(Tabs)(() => ({
  '& .MuiTabs-flexContainer': {
    justifyContent: 'space-around',
  },
  borderBottom: 'var(--border-dark)',
}));

export const TabIndicatorStyles: SxProps = {
  borderTopLeftRadius: 'var(--border-radius-medium)',
  borderTopRightRadius: 'var(--border-radius-medium)',
  height: 'var(--spacing-tiny)',
};
